import { render, staticRenderFns } from "./ReturnRefundPolicy.vue?vue&type=template&id=0ad91258&"
import script from "./ReturnRefundPolicy.vue?vue&type=script&lang=js&"
export * from "./ReturnRefundPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports